package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.constants.StringConstants.DATE_SYMBOL
import com.eladfinish.bible.contest.screens.search.model.SearchNumberOrRoot

class ExtractSpecialSearchQueryUseCase {

    operator fun invoke(
        searchNumberOrRoot: SearchNumberOrRoot,
        regex: String,
    ): String =
        when (searchNumberOrRoot) {
            SearchNumberOrRoot.NUMBER -> extractNumberFromRegex(regex)
            SearchNumberOrRoot.ROOT -> extractRootFromRegex(regex)
            SearchNumberOrRoot.DATE -> extractDateFromRegex(regex)
        }

    /** The typed date text, as it will be reported to analytics. */
    private fun extractDateFromRegex(regex: String): String =
        regex.replace(DATE_SYMBOL, "").trim()

    private fun extractNumberFromRegex(regex: String): String =
        regex.drop(1)

    private fun extractRootFromRegex(regex: String): String {
        val root = regex.removePrefix("√")
        val lastChar = root.lastOrNull() ?: return root

        val normalizedLastChar = when (lastChar) {
            'ך' -> 'כ'
            'ם' -> 'מ'
            'ן' -> 'נ'
            'ף' -> 'פ'
            'ץ' -> 'צ'
            else -> return root
        }

        return root.dropLast(1) + normalizedLastChar
    }
}
